import { Component, ElementRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { HelpItem } from '../../components/help/help.component';
import { NavGroup } from '../../components/side-nav/side-nav.component';
import { OnboardingStatusService } from '../../services/onboarding-status.service';
import { OnboardingStatus } from '../../services/types';

@Component({
    templateUrl: './pay-your-team.template.html',
    styleUrls: ['../../self-serve.style.scss'],
})
export class PayYourTeamView {
    navGroups: NavGroup[] = [];
    helpItems: HelpItem[] = [];

    private onboardingStatus: OnboardingStatus | null = null;

    constructor(
        private router: Router,
        private onboardingStatusService: OnboardingStatusService,
        private elementRef: ElementRef
    ) {
        this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const content = this.elementRef.nativeElement.querySelector('.self-serve-content');
                content?.scrollIntoView();
            }
        });

        this.onboardingStatusService.onboardingStatus$.pipe(takeUntilDestroyed()).subscribe((onboardingStatus) => {
            this.onboardingStatus = onboardingStatus;
            this.setNavGroups();
        });
    }

    private setNavGroups(): void {
        const navGroups: NavGroup[] = [
            {
                title: 'self-serve.payYourTeam.getReadyToPayYourTeam',
                steps: [
                    {
                        text: 'self-serve.payYourTeam.sideNav.addYourCraAccount',
                        href: 'cra-account',
                        complete: this.onboardingStatus?.payYourTeam.steps.craAccount ?? false,
                    },
                    {
                        text: 'self-serve.payYourTeam.sideNav.addYourBankAccount',
                        href: 'bank-account',
                        complete: this.onboardingStatus?.payYourTeam.steps.bankAccount ?? false,
                    },
                    {
                        text: 'self-serve.payYourTeam.sideNav.completeYourCompanyProfile',
                        href: 'company-profile',
                        complete: this.onboardingStatus?.payYourTeam.steps.companyProfile ?? false,
                    },
                    {
                        text: 'self-serve.payYourTeam.sideNav.completeYourProfile',
                        href: 'admin-profile',
                        complete: this.onboardingStatus?.payYourTeam.steps.adminProfile ?? false,
                    },
                    {
                        text: 'self-serve.payYourTeam.sideNav.addYourTeam',
                        href: 'add-team',
                        complete: this.onboardingStatus?.payYourTeam.steps.addTeam ?? false,
                    },
                ],
            },
        ];

        this.navGroups = navGroups;
    }
}
